import React from 'react';
import { FileText, Sparkles, CheckCircle2, CreditCard } from 'lucide-react';

const STEPS = [
  { n: '01', icon: FileText,    title: 'Brief',   desc: 'Tell us what you want — endorsement, video, survey, advisory call, anything. 5 min.' },
  { n: '02', icon: Sparkles,    title: 'Match',   desc: 'We match you with verified executives in your ICP. Auto or hand-picked.' },
  { n: '03', icon: CheckCircle2,title: 'Approve', desc: 'You review every deliverable before publishing. Revisions free. No surprises.' },
  { n: '04', icon: CreditCard,  title: 'Pay',     desc: 'Pay only what you approve. Stripe-secured. Execs get paid within 48 h.' },
];

export default function ProcessSteps() {
  return (
    <section className="py-24 sm:py-32 border-t border-white/5" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-14 sm:mb-20">
          <p className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#FF4343] mb-3">★ We do it all ★</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Our <span className="text-[#FF4343]">end-to-end</span> process.
          </h2>
          <p className="text-sm sm:text-base text-[#9CA3AF] max-w-2xl mx-auto mt-4">
            From brief to payout in 4 steps. We match, manage, and measure — so you never chase a deliverable
            or negotiate with 12 different executives.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {STEPS.map((s, i) => (
            <div key={i} data-testid={`process-step-${i}`}
              className="relative bg-[#111827] border border-white/10 p-6 sm:p-7 hover:border-[#FF4343]/40 transition-colors group">
              <div className="absolute top-4 right-4 text-[10px] font-mono text-[#6B7280] group-hover:text-[#FF4343] transition-colors">{s.n}</div>
              <s.icon className="w-7 h-7 sm:w-8 sm:h-8 text-[#FF4343] mb-4" />
              <h3 className="font-display text-xl sm:text-2xl font-bold mb-2">{s.title}</h3>
              <p className="text-xs sm:text-sm text-[#9CA3AF] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
